import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_ElFormItem = _resolveComponent("ElFormItem")!
  const _component_MessageLayout = _resolveComponent("MessageLayout")!

  return (_openBlock(), _createBlock(_component_MessageLayout, {
    image: "./email-cloud.svg",
    altText: "token expired",
    title: "Sorry!"
  }, {
    action: _withCtx(() => [
      _createVNode(_component_ElFormItem, { class: "el-form-item--xl-margin" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_button, { onClick: _ctx.tryAgain }, {
            default: _withCtx(() => _cache[0] || (_cache[0] = [
              _createTextVNode("Sign Up")
            ])),
            _: 1,
            __: [0]
          }, 8, ["onClick"])
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _cache[1] || (_cache[1] = _createTextVNode(" Your email verification link has expired. Click the button below to sign up again. "))
    ]),
    _: 1,
    __: [1]
  }))
}